module.exports = __webpack_public_path__ + "img/vf4.385e3d86.png";